import React from "react";
import { Link } from "react-router-dom";
import "./ServicesDetail.css";

// If images are inside src/assets/images
import orthopaedicImg from "../../assets/images/orthopaedic.jpg";

function OrthopaedicPT() {
  return (
    <div className="service-detail-container">
      {/* LEFT SIDE IMAGE */}
      <div className="service-detail-image">
        <img src={orthopaedicImg} alt="Orthopaedic Physical Therapy" />
      </div>

      {/* RIGHT SIDE CONTENT */}
      <div className="service-detail-content">
        <h2>Orthopaedic Physical Therapy</h2>
        <p>
          Our orthopaedic physical therapy program focuses on treating
          musculoskeletal injuries, helping patients regain strength and mobility.
        </p>
        <p>
          <strong>When is it needed?</strong>
          If you’ve recently experienced a sports injury, joint pain, or have chronic
          movement limitations caused by bone or muscle conditions, orthopaedic PT can
          help.
        </p>
        <ul className="service-bullet-list">
          <li>Post-fracture rehabilitation</li>
          <li>Arthritis management</li>
          <li>Joint replacement pre- and post-op therapy</li>
        </ul>
        <p>
          We use a tailored approach combining manual therapy techniques,
          personalized exercise programs, and patient education to ensure a
          faster recovery and a safe return to daily activities.
        </p>

        <Link to="/contact" className="service-cta-button">
          Contact Us to Learn More
        </Link>
      </div>
    </div>
  );
}

export default OrthopaedicPT;
